module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog\"> <div class=\"modal-content\"> <section class=\"modal-header\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> <h3>Error Adding Credit Card</h3> </section> <section class=\"modal-body\"> <p>")
    ; __append(escapeFn( locals.message ))
    ; __append("</p> </section> <section class=\"modal-footer\"> <button class=\"btn btn-red okay\" type=\"button\"> Okay </button> </section> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/credit_card_error_modal.ejs
// module id = 887
// module chunks = 1